<h2>Person i politiskt utsatt ställning (PEP)</h2>

<p class="select-title">Har du ett yrke som gör att du är en person i politiskt
  utsatt ställning
  (PEP) eller är du anhörig alternativt nära medarbetare till någon i politiskt
  utsatt ställning (RCA)? <a
    href="https://www.swedishbankers.se/foer-bankkunder/penningtvaett/personer-i-politisk-utsatt-staellning-pep"
    target="_blank">Klicka här för att läsa mer.</a></p>

<form [formGroup]="pepForm()">
  <div class="margin-bottom-medium">
    <div
      [class.selection-error]="pepForm().get('pepStatus')?.invalid && pepForm().get('pepStatus')?.touched"
    >
      <mat-radio-group
        tabindex="0"
        formControlName="pepStatus"
        aria-required="true"
        [attr.aria-invalid]="pepForm().get('pepStatus')?.invalid && pepForm().get('pepStatus')?.touched"
        [attr.aria-describedby]="pepForm().get('pepStatus')?.invalid && pepForm().get('pepStatus')?.touched ? 'pep-status-error' : null">
        @for (option of pepStatus; track $index) {
          <div class="margin-bottom-small"
               [class.small-screen]="orientationService.isSmallScreen()">
            <mat-radio-button
              [value]="option.value">
              {{ option.label }}
            </mat-radio-button>
          </div>
        }
      </mat-radio-group>
    </div>

    @if (pepForm().get('pepStatus')?.invalid && pepForm().get('pepStatus')?.touched) {
      <div class="mat-error-container">
        <mat-icon aria-hidden="true" class="negative">priority_high</mat-icon>
        <mat-error id="pep-status-error">Vänligen gör ett val</mat-error>
      </div>
    }
  </div>

  @if (pepForm().get('pepStatus')!.value === 'pep' ||
  pepForm().get('pepStatus')!.value === 'rca') {
    <div class="column"
         [class.selection-error]="(pepForm().controls.pepPosition.errors && pepForm().controls.pepPosition.touched) && (pepForm().controls.pepCountry.errors && pepForm().controls.pepCountry.touched) || (validatePepYouStatus && !pepForm().value.pepTitle)"
         [attr.aria-describedby]="(pepForm().controls.pepPosition.errors && pepForm().controls.pepPosition.touched) && (pepForm().controls.pepCountry.errors && pepForm().controls.pepCountry.touched) || (validatePepYouStatus && !pepForm().value.pepTitle) ? 'pep-title-you-error' : null">
      <p class="select-title">Vänligen specificera arbetstiteln för
        {{ pepForm().get('pepStatus')!.value === 'pep' ? 'dig' : 'personen' }} i
        politiskt utsatt ställning</p>
      @for (option of pepTitles; track $index) {
        <div class="margin-bottom-small"
             [class.small-screen]="orientationService.isSmallScreen()"
        >
          <mat-checkbox
            [checked]="option.value === pepForm().controls.pepTitle.value"
            (change)="onCheckboxChange(option.value, 'pepTitle', $event.checked)"
            (keydown.enter)="onCheckboxChange(option.value, 'pepTitle', !(option.value === pepForm().controls.pepTitle.value)); $event.preventDefault()"
            aria-required="true"
            [class.selection-error]="pepForm().get('pepTitle')?.invalid && pepForm().get('pepTitle')?.touched"
            [attr.aria-invalid]="pepForm().get('pepTitle')?.invalid && pepForm().get('pepTitle')?.touched"
            [attr.aria-describedby]="'pep-title-error'"
            (keydown)="$index === pepTitles.length - 1 ? (validatePepYouStatus = true) : null"
          >
            {{ option.label }}
          </mat-checkbox>
        </div>

        @if (option.value === pepForm().controls.pepTitle.value) {
          <mat-form-field
            [class.small-screen]="orientationService.isSmallScreen()"
          >
            <mat-label>Ange befattning och organisation</mat-label>
            <input matInput formControlName="pepPosition"
                   placeholder="Fritext">

            @if (pepForm().controls.pepPosition.errors && pepForm().controls.pepPosition.touched) {
              <mat-icon matIconSuffix aria-hidden="true">
                priority_high
              </mat-icon>
            }

            @if (pepForm().controls.pepPosition.touched) {
              <mat-error>Vänligen ange befattning och organisation</mat-error>
            }
          </mat-form-field>

          <div>
            <mat-form-field
              [class.small-screen]="orientationService.isSmallScreen()"
            >
              <mat-label>Välj land</mat-label>
              <mat-select
                placeholder="Välj land"
                formControlName="pepCountry">
                @for (country of countryList; track $index) {
                  <mat-option
                    [class]="{'separator-after': $index === 0}"
                    [value]="country.name">{{ country.name }}
                  </mat-option>
                }
              </mat-select>

              @if (pepForm().controls.pepCountry.errors && pepForm().controls.pepCountry.touched) {
                <mat-icon matIconSuffix aria-hidden="true">
                  priority_high
                </mat-icon>
              }

              <mat-error>Vänligen gör ett val</mat-error>
            </mat-form-field>
          </div>
        }
      }

      @if (pepForm().get('pepTitle')?.invalid && pepForm().get('pepTitle')?.touched) {
        <div class="mat-error-container">
          <mat-icon aria-hidden="true">priority_high</mat-icon>
          <mat-error id="pep-title-error">Vänligen välj en titel</mat-error>
        </div>
      }
    </div>
    @if ((pepForm().controls.pepPosition.errors && pepForm().controls.pepPosition.touched) && (pepForm().controls.pepCountry.errors && pepForm().controls.pepCountry.touched) || (validatePepYouStatus && !pepForm().value.pepTitle)) {
      <div class="mat-error-container">
        <mat-icon
          class="negative"
          aria-hidden="true">
          priority_high
        </mat-icon>

        <mat-error id="pep-title-you-error">
          Du behöver göra ett val för att kunna fortsätta
        </mat-error>
      </div>
    }
    @if (pepForm().get('pepStatus')!.value === 'rca') {
      <div class="column"
           [class.selection-error]="pepForm().get('pepRelation')?.invalid && pepForm().get('pepRelation')?.touched || (validatePepOtherStatus && !pepForm().value.pepRelation)"
           [attr.aria-describedby]="pepForm().get('pepRelation')?.invalid && pepForm().get('pepRelation')?.touched || (validatePepOtherStatus && !pepForm().value.pepRelation) ? 'pep-title-other-error' : null">
        <p class="select-title">Vilken relation har du till personen i
          politiskt utsatt
          ställning?</p>
        @for (option of rcaRelations; track $index) {
          <div class="margin-bottom-small"
               [class.small-screen]="orientationService.isSmallScreen()">
            <mat-checkbox
              [checked]="option.value === pepForm().controls.pepRelation.value"
              (change)="onCheckboxChange(option.value, 'pepRelation', $event.checked)"
              (keydown.enter)="onCheckboxChange(option.value, 'pepRelation', !(option.value === pepForm().controls.pepRelation.value)); $event.preventDefault()"
              aria-required="true"
              [class.selection-error]="pepForm().get('pepRelation')?.invalid && pepForm().get('pepRelation')?.touched"
              [attr.aria-invalid]="pepForm().get('pepRelation')?.invalid && pepForm().get('pepRelation')?.touched"
              [attr.aria-describedby]="'pep-title-other-error'"
              (keydown)="$index === rcaRelations.length - 1 ? (validatePepOtherStatus = true) : null">
              {{ option.label }}
            </mat-checkbox>
          </div>
        }

        @if (pepForm().get('pepRelation')?.invalid && pepForm().get('pepRelation')?.touched) {
          <div class="mat-error-container">
            <mat-icon aria-hidden="true">priority_high</mat-icon>
            <mat-error id="pep-relation-error">Vänligen välj en relation
            </mat-error>
          </div>
        }
      </div>

      @if (validatePepOtherStatus && !pepForm().value.pepRelation) {
        <div class="mat-error-container">
          <mat-icon
            class="negative"
            aria-hidden="true">
            priority_high
          </mat-icon>

          <mat-error id="pep-relation-error">
            Du behöver göra ett val för att kunna fortsätta
          </mat-error>
        </div>
      }
    }

    @if (pepForm().get('pepStatus')!.value === 'pep') {
      <mat-checkbox
        [style.margin-top.rem]="1.25"
        formControlName="pepOtherWork"
        (keydown.enter)="pepForm().patchValue({pepOtherWork: !pepForm().get('pepOtherWork')?.value}); $event.preventDefault()">
        Jag har förutom ovan även fler arbete i politiskt utsatt ställning
      </mat-checkbox>
      @if (pepForm().controls.pepOtherWork.value) {
        <p class="select-title" [style.max-width.rem]="28.125">
          {{ pepWorkText }}
        </p>
        <mat-form-field
          class="text-area"
          [class.small-screen]="orientationService.isSmallScreen()"
        >
          <textarea matInput
                    formControlName="pepOtherWorkInfo"
                    [placeholder]="pepWorkText"
                    placeholder=""
                    rows="4"></textarea>
        </mat-form-field>
      }
    }

    <mat-checkbox
      [style.margin-top.rem]="1.25"
      formControlName="pepOtherRelation"
      (keydown.enter)="pepForm().patchValue({pepOtherRelation: !pepForm().get('pepOtherRelation')?.value}); $event.preventDefault()">
      {{
        pepForm().get('pepStatus')!.value === 'pep' ?
          'Jag är dessutom anhörig alternativt nära medarbetare till någon som är, eller de senaste 18 månaderna varit, en person i politiskt utsatt ställning (RCA)' :
          'Jag har förutom ovan även relation till fler personer i politiskt utsatt ställning'
      }}
    </mat-checkbox>
    @if (pepForm().controls.pepOtherRelation.value) {
      <p class="select-title" [style.max-width.rem]="28.125">
        {{
          pepForm().get('pepStatus')!.value === 'pep' ?
            pepRelationText :
            rcaRelationText
        }}
      </p>
      <mat-form-field
        class="text-area"
        [class.small-screen]="orientationService.isSmallScreen()"
      >
        <textarea matInput
                  formControlName="pepOtherRelationInfo"
                  [placeholder]="pepForm().get('pepStatus')!.value === 'pep' ?
                 pepRelationText :
                 rcaRelationText"
                  placeholder=""
                  rows="4"></textarea>
      </mat-form-field>
    }
  }
</form>